import { arrayMove } from '@dnd-kit/sortable'

export function applyNavItemSortOrder(items = []) {
  if (!Array.isArray(items)) {
    return []
  }

  return items.map((item, index) => ({
    ...item,
    sort_order: index,
  }))
}

export function reorderNavItemsByDrag(items = [], activeId, overId) {
  if (!Array.isArray(items) || activeId === overId) {
    return items
  }

  const oldIndex = items.findIndex((item) => item?.id === activeId)
  const newIndex = items.findIndex((item) => item?.id === overId)

  if (oldIndex === -1 || newIndex === -1) {
    return items
  }

  return applyNavItemSortOrder(arrayMove(items, oldIndex, newIndex))
}
